import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import MetaPixel from './global/metapixel';
import { Rating } from '@siamf/rating'

const MetaAdLandings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const amazonLink = 'https://www.amazon.com/Wild-Blood-Jute-Foster-ebook/dp/B0G368LY8C?maas=maas_adg_1B667C0D9921A3EA835740D6E6145A95_afap_abs&ref_=aa_maas&tag=maas';
  const grRating = 4.24;
  const grRatingsCount = 79;
  const grReviewCount = 69;
  const amazonRating = 4.0;
  const amazonRatingsCount = 32;
  const amazonReviewCount = 22;

  const handleClick = (event) => {
    event.preventDefault();
    let fbc = document.cookie
      .split('; ')
      .find(row => row.startsWith('_fbc='))
      ?.split('=')[1];
    if (!fbc) {
      const fbclid = searchParams.get("fbclid");
      if (fbclid) {
        fbc = 'fb.1.' + Date.now() + '.' + fbclid;
      }
    }
    if (fbc === undefined) {
      fbc = '';
    }
    const event_id_val = Date.now();
    const q = new URLSearchParams({ ts: event_id_val }).toString();
    // navigator.sendBeacon('/api/log?' + q + '&c=' + btoa(fbc));
    fetch('/api/log?' + q + '&c=' + btoa(fbc));
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {}, { eventID: event_id_val });
    }
    window.location.href = amazonLink;
  };

  return (
    <section className="section-padding bg-one">
      <MetaPixel />
      <div className="container min-vh-100">
        <div className="row fixed-top">
          <button onClick={handleClick} className="smooth button button__primary">
            <span>👆 Get on Amazon now! 👆</span>
          </button>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <h4 className="text-center">
              <p>A desperate fugitive, magic stolen.</p>
              <p>A broken legend, hollowed out by loss.</p>
              <p>The earth-shattering event that brings them together.</p>
            </h4>
            <div className="text-center">
              <button onClick={handleClick} className="smooth button button__primary">
                <span>Read on Kindle Unlimited or buy now!</span>
              </button>
            </div>
            <div className='row pt-4 text-dark justify-content-center'>
              <div className='col d-flex justify-content-center'>
                <div>
                  <a href='https://www.goodreads.com/book/show/244211928-wild-blood'><u>Wild Blood on Goodreads</u></a>
                  <div className='d-flex'>
                    <div>
                      <Rating
                        value={grRating}
                        fractions={0.01}
                        readOnly={true}
                      />
                    </div>
                    <div className='ps-3 fw-bold'>{grRating}</div>
                  </div>
                  <div>Ratings: {grRatingsCount}</div>
                  <div>Reviews: {grReviewCount}</div>
                </div>
              </div>
              <div className='col d-flex justify-content-center'>
                <div>
                  <a href={amazonLink}><u>Wild Blood on Amazon</u></a>
                  <div className='d-flex align-items-center align-middle'>
                    <div>
                      <Rating
                        value={amazonRating}
                        fractions={0.1}
                        readOnly={true}
                      />
                    </div>
                    <div className='ps-3'><span className='fw-bold align-middle'>{amazonRating.toFixed(1)}</span></div>
                  </div>
                  <div>Ratings: {amazonRatingsCount}</div>
                  <div>Reviews: {amazonReviewCount}</div>
                </div>
              </div>
            </div>
            <div className="text-secondary-emphasis pt-4">
              <img className="float-end meta__insetimage" src="assets/images/wildblood_hero.jpg" width="200px" />
              <p>After five years of torture disguised as marriage, Gessa clawed her way to freedom. But sanctuary is not safety. Surrounded by recruits barely out of childhood, she is an outcast fighting to prove she isn't broken. She must master the wild magic ripping at her seams and silence the skepticism of the Academy, or lose the only chance she has to be truly free.</p>
              <img className="float-start" src="assets/images/kyleft.png" />
              <p>Instructor Ky lives in the wreckage of his legend, his failure carved into the scars on his leg and the silence in his soul. Once the realm’s greatest courier, he was shattered by a mission that killed his soul-bonded beast. Tasked with training her, he views Gessa as a terrifying echo of the recklessness that cost him everything.</p>
              <img className="float-end" src="assets/images/gessaright.png" />
              <p>When Gessa’s untamed power rips them from safety and dumps them in the lawless north, there is nowhere left to hide. Stripped of rank and rules, Ky becomes her only shield against the man hunting her, while Gessa becomes the spark that forces Ky to feel again. To survive, they must do the impossible: trust a partner with the power to break them.</p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="mx-auto col-md-6 pt-4">
            <h4 className="text-center">An adult romance for fans of Slow Burn, Broken Heroes and Magical Beasts.</h4>
            <img className="mx-auto d-block pt-6 meta__insetimage" src="assets/images/key2small.png" width="350px" />
          </div>
        </div>
      </div>
      <div className="row fixed-bottom">
        <button onClick={handleClick} className="smooth button button__primary">
          <span>👆 Get on Amazon now! 👆</span>
        </button>
      </div>
    </section>
  );
};

export default MetaAdLandings;